//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TABLET, MOBILE } from '@/scripts/constants/media-query'
export default {
  name: 'RbCrosslink',
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    imageDesktop: {
      type: String,
      default: '',
    },
    imageTablet: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    hasSwiper: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    hasSkeleton() {
      return this.label.includes('[[')
    },
    isActive() {
      const dataType = document.getElementById('pageType')?.value ?? ''
      return dataType === this.category
    },
    image() {
      if (this.$mq === TABLET && this.imageTablet) {
        return this.imageTablet
      }
      if (this.$mq === MOBILE && this.imageMobile) {
        return this.imageMobile
      }
      return this.imageDesktop
    },
  },
  mounted() {
    this.loading = false
  },
}
